// src/components/AboutUs.jsx
// Strona „O nas” - sygnały wiarygodności (E-E-A-T): kto prowadzi serwis,
// jak powstają treści, jak je aktualizujemy i gdzie weryfikować przepisy.
import React from 'react';
import { Link } from 'react-router-dom';
import styles from '../css/modules/Page.module.css';
import JsonLd from '../seo/JsonLd';
import { breadcrumbJsonLd, CONTACT_EMAIL } from '../seo/siteMeta';

const AboutUs = () => (
  <>
    <JsonLd
      data={breadcrumbJsonLd([
        { name: 'Strona główna', path: '/' },
        { name: 'O nas', path: '/o-nas' },
      ])}
    />

    <main className={styles.page}>
      <article className={styles.wrap}>
        <nav className={styles.breadcrumbs} aria-label="Ścieżka nawigacji">
          <Link to="/">Strona główna</Link> › <span>O nas</span>
        </nav>

        <h1 className={styles.h1}>O serwisie Strzelasz.pl</h1>

        <p className={styles.lead}>
          Strzelasz.pl to polska platforma z testami online przygotowującymi do egzaminu
          teoretycznego na <strong>patent strzelecki PZSS</strong> oraz do dalszej ścieżki
          po <strong>pozwolenie na broń</strong>.
        </p>

        <section className={styles.section}>
          <h2>Po co powstał serwis</h2>
          <p>
            Część teoretyczna egzaminu na patent strzelecki opiera się na przepisach, które
            trudno przyswoić z samego czytania ustaw. Zbudowaliśmy narzędzie, w którym uczysz
            się tak, jak będziesz zdawać: na pytaniach, z wyjaśnieniem każdej odpowiedzi
            i z powtórkami tego, czego jeszcze nie umiesz.
          </p>
          <p>
            Formuła pojedynku zamiast klasycznej listy pytań nie jest ozdobnikiem - ma jeden
            cel: sprawić, żeby codzienna powtórka była na tyle wciągająca, by faktycznie do niej
            wracać przez kilka tygodni przed egzaminem.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Jak przygotowujemy materiały</h2>
          <ul>
            <li>
              Zestawy pytań budujemy wokół zakresu wymaganego na egzaminie PZSS: ustawa
              o broni i amunicji, przepisy karne dotyczące broni, zasady bezpieczeństwa,
              regulamin strzelnicy oraz przepisy sportowe ISSF i PZSS.
            </li>
            <li>
              Odpowiedzi opatrujemy własnym wyjaśnieniem - tak, aby uczyć zrozumienia przepisu,
              a nie zapamiętywania litery odpowiedzi.
            </li>
            <li>
              Treści przeglądamy i aktualizujemy przy zmianach przepisów oraz regulaminów PZSS.
              Datę ostatniej aktualizacji podajemy na stronach przewodników.
            </li>
          </ul>
          <p className={styles.note}>
            Strzelasz.pl jest serwisem edukacyjnym. Nie jest oficjalną stroną Polskiego Związku
            Strzelectwa Sportowego ani Policji i nie zastępuje aktualnych aktów prawnych ani
            regulaminów. W sprawach formalnych zawsze potwierdzaj wymagania w swoim klubie,
            w PZSS i w obowiązujących przepisach.
          </p>
        </section>

        <section className={styles.section}>
          <h2>Kto prowadzi serwis</h2>
          <p>
            Właścicielem i administratorem serwisu jest <strong className="dane-adm-nazwa" />,{' '}
            <span className="dane-adm-adres" />. Kontakt:{' '}
            <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>.
          </p>
          <p>
            Pełne zasady korzystania z serwisu opisuje <Link to="/regulamin">regulamin</Link>,
            a zasady przetwarzania danych -{' '}
            <Link to="/polityka-prywatnosci">polityka prywatności</Link>.
          </p>
        </section>

        <div className={styles.ctaBox}>
          <h2>Zacznij od darmowego testu</h2>
          <p>Sprawdź formę nauki bez rejestracji i bez opłat.</p>
          <div className={styles.ctaRow}>
            <Link to="/intro" className={styles.primaryButton}>
              Rozwiąż darmowy test
            </Link>
            <Link to="/patent-strzelecki" className={styles.secondaryButton}>
              Przewodnik po patencie
            </Link>
          </div>
        </div>
      </article>
    </main>
  </>
);

export default AboutUs;
